import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { Constants } from '../../common';
import { ChangeUserNameAndPasswordForm } from '../../interface';
import { Mapper } from '../mapper/mapper';
import { BaseAPI } from './base-api';

@Injectable({
  providedIn: 'root',
})
export class UserProfileApi {
  constructor(private baseAPI: BaseAPI, private mapper: Mapper) {}

  changeUserNameAndPassword(form: ChangeUserNameAndPasswordForm): Observable<string> {
    return this.baseAPI.post(Constants.UPDATE_USER_INFO_API_URL, form).pipe(
      map((res) => {
        return res.accessToken;
      })
    );
  }
}
